import React from 'react';

const InteractionBar = ({ engagement, organic, paid }) => {
  // 1. Determine Opacity based on the logic provided in your image
  const getOpacity = (value) => {
    if (value < 100) return 0.4;
    if (value < 1000) return 0.4;
    if (value < 10000) return 0.6;
    if (value < 100000) return 0.8;
    return 1.0; // 100,000 and above
  };

  const opacity = getOpacity(paid);
  const paidColor = `rgba(204, 45, 101, ${opacity})`;

  // Calculate widths for the flex container
  const total = organic + paid;
  const engagementWidth = (engagement / total) * 100;
  const organicWidth = (organic / total) * 100;
  const paidWidth = (paid / total) * 100;

   return (
    <div style={{
      display: 'flex',
      // maxWidth: '200px',
      width: '100%',
      minWidth: '100px',
      height: '37px',
      border: '1px solid #ddd',
      overflow: 'hidden',
      color: '#fff',
      fontSize: '14px',
      padding: '4px'
    }}>

      {/* Engagement Section */}
      {engagement>0 && (
        <div style={{
          backgroundColor: `rgba(34, 160, 180, ${getOpacity(engagement)})`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: '50%',
          width: '100%',
          fontSize: '13px'
        }}>
            {engagement.toLocaleString()}
        </div>)}

      {/* Organic Section */}
      {organic>0 && (
        <div style={{
          backgroundColor: `rgba(160, 78, 181, ${getOpacity(organic)})`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: '50%',
          width: '100%',
          fontSize: '13px'
        }}>
            {organic.toLocaleString()}
        </div>)}

        {/* Paid Section */}
        {paid>0 && (
            <div style={{
            minWidth: '50%',
            width: '100%',
            backgroundColor: `rgba(204, 45, 101, ${getOpacity(paid)})`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '13px'
        }}>
            {paid.toLocaleString()}
        </div>)}
    </div>
  );
};

export default InteractionBar;